import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import { Link, Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import Box from "@mui/material/Box"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import Snackbar from "@mui/material/Snackbar"
import Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import { useSelector } from "react-redux"
import { logOut } from "../../../utils/logOut"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import TranslatedText from "../../../utils/Translate"
import { FormControlLabel, IconButton, Modal, Paper } from "@mui/material"
import CodeMirror from '@uiw/react-codemirror';
import { materialLight } from "@uiw/codemirror-theme-material"
import { langs } from "@uiw/codemirror-extensions-langs"
import { languages } from "@codemirror/language-data"
import { markdown, markdownLanguage } from "@codemirror/lang-markdown"
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { javascript } from "@codemirror/lang-javascript";
import { LanguageSupport } from "@codemirror/language";
import { LanguageDescription } from "@codemirror/language";
import { useSnackbar } from "../../../utils/SnackbarContext"
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'


export default function Function() {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [snackbarType, setSnackbarType] = useState("")
    const [partners, setPartners] = useState([])
    const [aiparams, setAiParams] = useState([])
    const [publications, setPublications] = useState([])
    const [openDeleteModal, setOpenDeleteModal] = React.useState<{
        id: number | string;
        type: 'parameter' | 'publication';
    } | null>(null);
    const [openEditModal, setOpenEditModal] = React.useState(false);
    const [currentParameter, setCurrentParameter] = React.useState('0');

    const { showSnackbar } = useSnackbar();


    const handleDeleteModalOpen = (id: number | string, type: 'parameter' | 'publication') => {
        setOpenDeleteModal({ id, type })
    };

    const handleDeleteModalClose = () => setOpenDeleteModal(null);

    const handleConfirmDelete = () => {
        if (!openDeleteModal) return;

        if (openDeleteModal.type === 'parameter') {
            handleDeleteParameter(openDeleteModal.id);
        } else {
            handleDeletePublication(openDeleteModal.id);
        }
    };


    const Modalstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 400,
        maxWidth: 800,
        width: '40%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };


    //Get params from URL
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    const aipromptid = params.get('aipromptid');
    const folder_id = params.get('folder_id');
    const type: string | null = params.get('type')

    //Get access level
    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    //Switch header title
    useEffect(() => {
        dispatch(setCurrentPage(type === "edit" ? `Edit AI Function` : 'Add AI Function'))
    }, [dispatch]);


    //Handle close snackbar
    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    //Making request to get partners list
    async function getPartners(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/partner`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setPartners(response.data)

        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Get did
    async function fetchData(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/aifunctionsv2/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            if (response.data !== null) {
                setAIFunctionData({ ...response.data, "required": response.data['required'] == 0 ? '0' : '1', "api_code": response.data['api_code'] || '', 'allowed_once': response.data['allowed_once'] == 0 ? '0' : response.data['allowed_once'] == 1 ? '1' : '2', 'save_tool_use': response.data['save_tool_use'] || 'no', 'showsetuptopartner': response.data['showsetuptopartner'] == 1 ? '1' : '0', partner: response.data['partner'] != null ? String(response.data['partner']) : '' })
            }

            console.log(response.data);

        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Create func
    async function postData(data: any = {}) {
        try {
            const response = await axios.post(`https://cardgarantsales.com/restapi/aifunctionsv2`, {
                ...AIFunctionData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    //Edit func
    async function putData(data: any = {}) {
        try {
            const response = await axios.put(`https://cardgarantsales.com/restapi/aifunctionsv2/${id}`, {
                ...AIFunctionData
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })

            setSnackbarType('success')
            setOpenSnackbar(true)
        } catch (error: any) {
            setSnackbarType('error')
            setOpenSnackbar(true)
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }


    const [AIFunctionData, setAIFunctionData] = useState<any>(type === 'edit' ? [] :
        {
            "aiprompt": aipromptid || null,
            "parent": folder_id || null,
            "name": '',
            "description": '',
            "required": '0',
            "api_code": '',
            'allowed_once': '0',
            'save_tool_use': 'no',
            'type': 'function',
            'readonlyhint': '',
        }
    )

    async function getAIParams(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/aiparameters`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setAiParams(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    async function handleDeleteParameter(id: any) {
        try {
            const response = await axios.delete(`https://cardgarantsales.com/restapi/aiparameters/` + id, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })
            setAiParams(aiparams.filter((row: any) => row.id !== id))
            handleDeleteModalClose()
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    async function getPublications(params: object = {}) {
        try {
            const response = await axios.get(`https://cardgarantsales.com/restapi/functionpublications`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                }, params: params
            })
            console.log(response.data);
            setPublications(response.data)
        } catch (error: any) {
            console.log(error);
            if (error.message === "Request failed with status code 401") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }

    async function handleDeletePublication(id: any) {
        try {
            const response = await axios.delete(`https://cardgarantsales.com/restapi/functionpublications/` + id, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
            })
            setPublications(publications.filter((row: any) => row.id !== id))
            handleDeleteModalClose()
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
        }
    }



    useEffect(() => {
        accesslevel === "5" && getPartners()
        type === 'edit' && fetchData()
        type === 'edit' && getAIParams({ 'function': id })
        type === 'edit' && getPublications({ 'function': id })
        console.log(AIFunctionData);

    }, [])

    const truncateString = (s: string, w: number) => s.length > w ? s.slice(0, w) + "..." : s;

    function customLanguage() {
        return new LanguageSupport(javascript().language);
    }

    const customLangDescription = LanguageDescription.of({
        name: "code",
        support: customLanguage()
    });


    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', width: '100%' }}>
                <Box sx={{ maxWidth: 1220, width: '90vw' }}>
                    <Button fullWidth sx={{mb:2, gap:1}} size="small" variant="outlined" component={Link} to={`/functions?folder_id=${folder_id || AIFunctionData.parent || ''}`}>
                        <ArrowBackIosNewIcon sx={{ fontSize: 14 }}  />
                        <TranslatedText text="Go back" />
                    </Button>
                    <Paper elevation={3} sx={{ padding: 2, mb: 2 }}>
                        <Typography sx={{ width: '100%', mb: 2, display: 'flex', alignItems: 'center', gap: 3, justifyContent: 'space-between' }} variant="h5">
                            <TranslatedText text={'AI Function'} />
                            <Typography variant="body1">
                                {AIFunctionData['path'] ? AIFunctionData['path'] : ''}{AIFunctionData['name'] ? AIFunctionData['name'] : ''}
                            </Typography>
                        </Typography>
                        <Box sx={{ p: 2, gap: 1, display: 'flex', flexDirection: 'column' }}>
                            {Number(accesslevel) === 5 &&
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap', mb: 1 }}>
                                    <FormControl sx={{ mr: 2 }}>
                                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Partner'} /></InputLabel>
                                        <Select sx={{ width: 223 }} labelId="simple-select-label" onChange={(e: any) => setAIFunctionData({ ...AIFunctionData, partner: e.target.value !== '' ? e.target.value : null })} value={AIFunctionData.partner || ''} variant="outlined" size="small" label={<TranslatedText text={'Partner'} />} >
                                            <MenuItem value="">Only admin</MenuItem>
                                            <MenuItem value={'0'}>Any</MenuItem>
                                            {
                                                partners.map((el: any) => {
                                                    //make partners list item
                                                    return (
                                                        <MenuItem key={el.id} value={el.id}>{el.partnerbankcode}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                    <FormControlLabel control={<Switch checked={AIFunctionData.showsetuptopartner == '1'} onChange={(e) => setAIFunctionData({ ...AIFunctionData, showsetuptopartner: e.target.checked ? '1' : '0' })} />} label={<TranslatedText text="Show setup to partner" />} />
                                </Box>
                            }
                            <TextField onChange={(e) => setAIFunctionData({ ...AIFunctionData, name: e.target.value !== '' ? e.target.value : null })} value={AIFunctionData.name || ''} sx={{ width: "100%", mb: 1 }} variant="outlined" size="small" label={<TranslatedText text={'Name'} />} />
                            <TextField key={AIFunctionData.description} rows={5} onBlur={(e) => setAIFunctionData({ ...AIFunctionData, description: e.target.value !== '' ? e.target.value : '' })} defaultValue={AIFunctionData.description || ''} multiline sx={{ width: "100%", mb: 1, '& textarea': { resize: 'vertical' } }} variant="outlined" size="small" label={<TranslatedText text={'Description'} />} />
                            {type === 'edit' && (
                                <TextField onChange={(e) => setAIFunctionData({ ...AIFunctionData, path: e.target.value !== '' ? e.target.value : null })} value={AIFunctionData.path || ''} sx={{ width: "100%", mb: 1 }} variant="outlined" size="small" label={<TranslatedText text={'Path'} />} />
                            )}
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, width: '100%' }}>
                                <FormControl sx={{ minWidth: 223, width: '33%' }}>
                                    <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Max number of calls'} /></InputLabel>
                                    <Select onChange={(e) => setAIFunctionData({ ...AIFunctionData, allowed_once: e.target.value !== '' ? e.target.value : null })} value={AIFunctionData.allowed_once || ''} sx={{ width: "100%" }} labelId="simple-select-label" variant="outlined" size="small" label={<TranslatedText text={'Max number of calls'} />}>
                                        <MenuItem value={'0'}>No limits</MenuItem>
                                        <MenuItem value={'1'}>One per AI call</MenuItem>
                                        <MenuItem value={'2'}>One per AI step</MenuItem>
                                    </Select>
                                </FormControl>
                                <>
                                    <FormControl sx={{ minWidth: 223, width: '33%' }}>
                                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={"Save function calls"} /></InputLabel>
                                        <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setAIFunctionData({ ...AIFunctionData, save_tool_use: e.target.value !== "" ? e.target.value : null })} value={AIFunctionData.save_tool_use || ''} variant="outlined" size="small" label={<TranslatedText text={"Save function calls"} />} >
                                            <MenuItem value={'no'}>No</MenuItem>
                                            <MenuItem value={'yes'}>Yes</MenuItem>
                                            <MenuItem value={'transcript'}>Transcript</MenuItem>
                                        </Select>
                                    </FormControl>
                                </>
                                 <>
                                    <FormControl sx={{ minWidth: 223, width: '33%' }}>
                                        <InputLabel size="small" id="simple-select-label"><TranslatedText text={"readOnlyHint"} /></InputLabel>
                                        <Select sx={{ minWidth: 223, width: '100%' }} labelId="simple-select-label" onChange={(e) => setAIFunctionData({ ...AIFunctionData, readonlyhint: e.target.value !== "" ? e.target.value : null })} value={AIFunctionData.readonlyhint || ''} variant="outlined" size="small" label={"readOnlyHint"} >
                                            <MenuItem value={''}>NONE</MenuItem>
                                            <MenuItem value={'READ'}>READ</MenuItem>
                                            <MenuItem value={'WRITE'}>WRITE</MenuItem>
                                            <MenuItem value={'DESTRUCTIVE'}>DESTRUCTIVE</MenuItem>
                                        </Select>
                                    </FormControl>
                                </>
                                <Box sx={{ display: "flex", alignItems: "center", minWidth: 223 }}>
                                    <Typography><TranslatedText text={'Required'} /></Typography>
                                    <Switch onChange={(e) => setAIFunctionData({ ...AIFunctionData, required: AIFunctionData.required == '0' ? '1' : '0' })} checked={Boolean(+AIFunctionData.required)} />
                                </Box>
                            </Box>

                        </Box>
                    </Paper>
                    <Paper elevation={3} sx={{ width: '100%', maxHeight: '500px', padding: 2, display: 'flex', flexDirection: 'column', mb: 2 }}>
                        <Typography sx={{ width: '100%', mb: 2 }} variant="h5"><TranslatedText text={'API Code'} /></Typography>
                        <Box sx={{ overflow: 'auto', p: 2 }}>
                            <CodeMirror
                                width="auto"
                                onChange={(e) => setAIFunctionData({ ...AIFunctionData, api_code: e !== '' ? e : '' })}
                                value={AIFunctionData.api_code || ''}
                                theme={materialLight} extensions={[
                                    // markdown({ codeLanguages: [customLangDescription] }),
                                    langs.javascript(),
                                ]} />
                        </Box>


                    </Paper>

                    {type != 'add' && <Paper elevation={3} sx={{ padding: 2, height: "100%", minHeight: 290, mb: 2 }}>
                        <Typography sx={{ width: '100%', mb: 2 }} variant="h5"><TranslatedText text={'Params'} /></Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', height: '83%', justifyContent: 'space-between' }}>
                            <Box sx={{ overflow: 'auto', p: 2, height: '90%' }}>
                                {aiparams.length != 0 ? aiparams.map((el: any) => {
                                    return (
                                        <Paper key={el.id} variant="outlined" sx={{ padding: 1, minHeight: 60, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box sx={{ width: '70%' }}>
                                                <Typography sx={{ width: '100%' }}>{el.name}</Typography>
                                                <Typography color="text.secondary" variant="body2" sx={{ textOverflow: 'ellipsis', overflow: "hidden", width: '100%' }}>
                                                    {truncateString(el.description, 50)}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Link to={`/aiparameter?id=${el.id}&type=edit`}>
                                                    <IconButton aria-label="edit" color="primary">
                                                        <EditIcon />
                                                    </IconButton>
                                                </Link>
                                                <IconButton aria-label="delete" color="error" onClick={() => handleDeleteModalOpen(el.id, 'parameter')}>
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </Box>
                                        </Paper>

                                    )
                                }
                                ) : <Typography sx={{ width: '100%', textAlign: 'center', }} color="text.secondary" variant="body2"><TranslatedText text={'No params'} /></Typography>
                                }

                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pt: 1 }}>
                                <Link to={`/aiparameter?aifunctionid=${id}&type=add`}>
                                    <Button variant="outlined" sx={{ width: "100%", maxWidth: 400, minWidth: 223 }}><TranslatedText text={'Add'} /></Button>
                                </Link>
                            </Box>
                        </Box>
                    </Paper>}
                      {type != 'add' && <Paper elevation={3} sx={{ padding: 2, height: "100%", minHeight: 290 }}>
                        <Typography sx={{ width: '100%', mb: 2 }} variant="h5"><TranslatedText text={'Publications'} /></Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', height: '83%', justifyContent: 'space-between' }}>
                            <Box sx={{ overflow: 'auto', p: 2, height: '90%' }}>
                                {publications.length != 0 ? publications.map((el: any) => {
                                    return (
                                        <Paper key={el.id} variant="outlined" sx={{ padding: 1, minHeight: 60, mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box sx={{ width: '70%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                    <Box sx={{ flexShrink: 0, ml: 1, backgroundColor: el.enabled == '1' ? 'success.main' : 'error.main', width: 10, height: 10, borderRadius: '50%' }} />
                                                    <Box sx={{ minWidth: 0 }}>
                                                        <Typography sx={{ width: '100%' }}>{el.path}</Typography>
                                                        <Typography color="text.secondary" variant="body2" sx={{ textOverflow: 'ellipsis', overflow: "hidden", width: '100%' }}>
                                                            {el.protocol}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box>
                                                <Link to={`/publication?id=${el.id}&type=edit`}>
                                                    <IconButton aria-label="edit" color="primary">
                                                        <EditIcon />
                                                    </IconButton>
                                                </Link>
                                                <IconButton aria-label="delete" color="error" onClick={() => handleDeleteModalOpen(el.id, 'publication')}>
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </Box>
                                        </Paper>

                                    )
                                }
                                ) : <Typography sx={{ width: '100%', textAlign: 'center', }} color="text.secondary" variant="body2"><TranslatedText text={'No publications'} /></Typography>
                                }

                            </Box>
                            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pt: 1 }}>
                                <Link to={`/publication?aifunctionid=${id}&type=add`}>
                                    <Button variant="outlined" sx={{ width: "100%", maxWidth: 400, minWidth: 223 }}><TranslatedText text={'Add'} /></Button>
                                </Link>
                            </Box>
                        </Box>
                    </Paper>}
                </Box>
            </Box>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', pt: 3 }}>
                <Button onClick={() => type === "edit" ? putData(AIFunctionData) : postData(AIFunctionData)} variant="contained" sx={{ width: "100%", maxWidth: 400, minWidth: 223 }}><TranslatedText text={'Save'} /></Button>
            </Box>
            {type !== 'edit' && snackbarType === 'success' && <Navigate to={`/functions?folder_id=${folder_id}`} />}
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleClose}>
                {snackbarType === 'error' ?
                    <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                        <TranslatedText text={'Saving error'} />
                    </Alert> :
                    <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                        <TranslatedText text={'Successfully saved'} />
                    </Alert>}
            </Snackbar>
            <Modal
                open={openDeleteModal !== null}
                onClose={handleDeleteModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={Modalstyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        <TranslatedText text="Delete object" />
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <TranslatedText text="Are you sure you want to delete this object?" />
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: "space-between", paddingTop: 2 }}>
                        <Button onClick={handleDeleteModalClose}><TranslatedText text="Cancel" /></Button>
                        <Button onClick={handleConfirmDelete} color='error'><TranslatedText text="Delete" /></Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    )
}